import { ProfileResources } from 'ihunter-common';
import { useFirebaseDatabase } from './useFirebaseDatabase';
import { useFirebaseStorage } from './useFirebaseStorage';

let photoUrlCache = {};

export function useProfile() {
    const { getData } = useFirebaseDatabase();
    const { getStorageDownloadURL } = useFirebaseStorage();

    const hasProfilePic = async (user) => {
        if (user.profilePicDate) {
            return true;
        }
        if (user.isGroupChat) {
            return false;
        }
        const picDate = await getData(ProfileResources.PictureDate(user.uid));
        return Boolean(picDate);
    };

    const getStoragePhotoURLForUser = async (user, useCache) => {
        if (!user?.uid) {
            return null;
        }

        if (photoUrlCache[user.uid] === undefined || !useCache) {
            const authPhotoURL = user.photoURL; // Fallback to their Auth IdP photo (e.g. Google, Apple account photo)
            try {
                const hasPic = await hasProfilePic(user);
                if (hasPic) {
                    // Attempt to get the photo the user has set for their iHunter account
                    photoUrlCache[user.uid] = await getStorageDownloadURL(ProfileResources.PictureStorage(user.uid));
                } else {
                    photoUrlCache[user.uid] = authPhotoURL;
                }
            } catch (error) {
                photoUrlCache[user.uid] = authPhotoURL;
            }
        }
        return photoUrlCache[user.uid];
    };

    return {
        getStoragePhotoURLForUser,
    };
}
